export class AltroImportoLiquidato {
  speseRegistrazione: number;
  contributoUnificato: number;
  altroImporto: number;
  rimborsoTerzoPignorato: number;
  id: string;
}
